<div class="content dark">
	<p>Other organizations besides {{asset.organization_name}} can be granted access to this
		asset.
	</p>
	<div *ngIf="assetPartners && assetPartners.length" class="partner-list">
		<p>Current partner organizations:</p>
		<div *ngFor="let partner of assetPartners" class="row">
			<div class="col-sm-10">
				{{partner.name}}
			</div>
			<div class="col-sm-2">
				<app-action-button [action]="DeletePartner" [args]="[partner.organization_id]" [context]="this" confirm="Are you sure?" processing="..." btnClass="btn-danger"
					title="Delete partnership">X
				</app-action-button>
			</div>
		</div>
	</div>
	<p>Add a partner organization</p>
	<div class="row">
		<div class="col-sm-8">
			<select [(ngModel)]="addPartnerOrg" class="form-control">
				<option *ngFor="let org of assetPotentialPartners" [ngValue]="org">{{org.name}}</option>
			</select>
		</div>
		<div class="col-sm-4">
			<app-action-button [action]="AddPartner" [disabled]="!addPartnerOrg" [context]="this" processing="Sharing..." complete="Asset shared">Share asset
			</app-action-button>
		</div>
	</div>
</div>